module.exports = __webpack_public_path__ + "static/media/ic_template_5.a5ab1bcd.png";